<template>
  <hr class="mx-auto max-w-xs rounded border-2 border-pink-500">
</template>
